/* ─────────────────────────────────────────────
   Finer & Co. — Base JS
   ───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  // ── INITCAPS ──────────────────────────────────
  // Wraps the first letter of every word in .hed elements
  // with .wf (word-first) for the 1.22em size treatment
  function applyInitcaps(el) {
    if (el.dataset.initcapsDone) return;
    el.dataset.initcapsDone = 'true';

    // Walk text nodes only — preserve child elements (spans, links etc.)
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) textNodes.push(node);

    textNodes.forEach(textNode => {
      const text = textNode.textContent;
      if (!text.trim()) return;

      const frag = document.createDocumentFragment();
      const words = text.split(/(\s+)/); // preserve whitespace

      words.forEach(part => {
        if (!part.trim()) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        // Wrap the whole word in a nowrap span so the large first letter
        // and the remaining letters can never break onto separate lines
        const word = document.createElement('span');
        word.style.whiteSpace = 'nowrap';
        const cap = document.createElement('span');
        cap.className = 'wf';
        cap.textContent = part[0];
        word.appendChild(cap);
        if (part.length > 1) {
          word.appendChild(document.createTextNode(part.slice(1)));
        }
        frag.appendChild(word);
      });

      textNode.replaceWith(frag);
    });
  }

  document.querySelectorAll('.hed').forEach(applyInitcaps);

  // Re-run on any dynamically added .hed elements
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.classList?.contains('hed')) applyInitcaps(node);
        node.querySelectorAll?.('.hed').forEach(applyInitcaps);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });


  // ── CONTACT PREFERENCE ────────────────────────
  const prefOpts = document.querySelectorAll('.form-pref__opt');
  const phoneRow = document.querySelector('.form-phone');

  prefOpts.forEach(opt => {
    opt.addEventListener('click', () => {
      prefOpts.forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      const needsPhone = opt.dataset.pref === 'text' || opt.dataset.pref === 'call';
      phoneRow?.classList.toggle('is-visible', needsPhone);
    });
  });


  // ── MOBILE NAV ────────────────────────────────
  const toggle = document.querySelector('.site-nav__mobile-toggle');
  const drawer = document.querySelector('.site-nav__drawer');
  const drawerClose = document.querySelector('.site-nav__drawer-close');

  toggle?.addEventListener('click', () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  drawerClose?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', e => {
    if (e.target === drawer) closeDrawer();
  });

  function closeDrawer() {
    drawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close drawer on nav link click
  document.querySelectorAll('.site-nav__drawer-links a').forEach(a => {
    a.addEventListener('click', closeDrawer);
  });

  // Escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });


  // ── ACTIVE NAV STATE ─────────────────────────
  // Marks current page link as active based on pathname
  const currentPath = window.location.pathname;
  document.querySelectorAll('.site-nav__links a, .site-nav__drawer-links a').forEach(a => {
    if (a.getAttribute('href') === currentPath) {
      a.classList.add('active');
    }
  });

});
